import { useViewportMatch } from "@wordpress/compose";
import { NEW_TAB_TARGET, NEW_TAB_REL, NOFOLLOW_REL } from "./constants";

export function prependHTTP(url) {
  return url.startsWith("http") ? url : `https://${url}`;
}

export function getUpdatedLinkAttributes({
  rel = "",
  url = "",
  opensInNewTab,
  nofollow,
}) {
  let newLinkTarget;
  // Since `rel` is editable attribute, we need to check for existing values and proceed accordingly.
  let updatedRel = rel;

  if (opensInNewTab) {
    newLinkTarget = NEW_TAB_TARGET;
    updatedRel = updatedRel?.includes(NEW_TAB_REL)
      ? updatedRel
      : updatedRel + ` ${NEW_TAB_REL}`;
  } else {
    const relRegex = new RegExp(`\\b${NEW_TAB_REL}\\s*`, "g");
    updatedRel = updatedRel?.replace(relRegex, "").trim();
  }

  if (nofollow) {
    updatedRel = updatedRel?.includes(NOFOLLOW_REL)
      ? updatedRel
      : (updatedRel + ` ${NOFOLLOW_REL}`).trim();
  } else {
    const relRegex = new RegExp(`\\b${NOFOLLOW_REL}\\s*`, "g");
    updatedRel = updatedRel?.replace(relRegex, "").trim();
  }

  return {
    url: prependHTTP(url),
    linkTarget: newLinkTarget,
    rel: updatedRel || undefined,
  };
}

export function useToolsPanelDropdownMenuProps() {
  const isMobile = useViewportMatch("medium", "<");
  return !isMobile
    ? {
        popoverProps: {
          placement: "left-start",
          // For non-mobile, inner sidebar width (248px) - button width (24px) - border (1px) + padding (16px) + spacing (20px)
          offset: 259,
        },
      }
    : {};
}
